import { render, staticRenderFns } from "./boundary.vue?vue&type=template&id=cb230d70&scoped=true"
import script from "./boundary.vue?vue&type=script&lang=js"
export * from "./boundary.vue?vue&type=script&lang=js"
import style0 from "./boundary.vue?vue&type=style&index=0&id=cb230d70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb230d70",
  null
  
)

export default component.exports